import { env } from "onnxruntime-web";

env.wasm.wasmPaths = "/";
